import type { OrderProduct } from "../OrderProduct.js";
import { type TaxLevel, taxLevelValueMap } from "../TaxLevel.js";

export function getDeliveryTaxLevel(products: OrderProduct[]): TaxLevel | null {
	let taxLevel: TaxLevel | null = null;

	for (const { product } of products) {
		if (taxLevel === null || taxLevelValueMap[product.price.taxLevel] > taxLevelValueMap[taxLevel]) {
			({ taxLevel } = product.price);
		}
	}

	return taxLevel;
}
